module.exports = __webpack_public_path__ + "static/g2-high-performer-f83e5ab344dbb8d6973ce0dda539c318.png";